import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=49028d5a&"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js&"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports